import tipoFormularioService from '../services/tipoFormularioService';

/** Convención maestro: 0 = Sí descuenta/reserva; 1 = No. */
const DESCUENTA_SI = 0;
const DESCUENTA_NO = 1;

const TIPO_REMITO = '9';

export type PoliticaStockResult = {
  remitoDescuenta: boolean;
};

let cachedOk: PoliticaStockResult | null = null;

function interpretaDescuenta(descuentaStock: number | null | undefined): boolean {
  return descuentaStock == null || Number(descuentaStock) === DESCUENTA_SI;
}

async function leerDescuenta(nroTipo: string): Promise<boolean | null> {
  try {
    const tipo = await tipoFormularioService.getTipoFormulario(nroTipo);
    return interpretaDescuenta(tipo.descuentaStock);
  } catch {
    return null;
  }
}

async function forzarDescuenta(nroTipo: string, debeDescontar: boolean): Promise<void> {
  try {
    const tipo = await tipoFormularioService.getTipoFormulario(nroTipo);
    const actual = interpretaDescuenta(tipo.descuentaStock);
    if (actual === debeDescontar) return;
    await tipoFormularioService.updateTipoFormulario(nroTipo, {
      ...tipo,
      descuentaStock: debeDescontar ? DESCUENTA_SI : DESCUENTA_NO,
    });
  } catch {
    /* sin permiso / tipo inexistente */
  }
}

/**
 * Asegura que el remito de venta (tipo 9) tenga DescuentaStock activo.
 * Pedido (12) reserva; factura (1) descuenta: flags configurados en TipoFormulario, no se alteran aquí.
 */
export async function asegurarStockSoloEnRemito(options?: {
  force?: boolean;
}): Promise<PoliticaStockResult> {
  if (cachedOk && !options?.force && cachedOk.remitoDescuenta) {
    return cachedOk;
  }

  await forzarDescuenta(TIPO_REMITO, true);

  const lecturaRemito = await leerDescuenta(TIPO_REMITO);
  const remitoDescuenta = lecturaRemito === true;

  const result: PoliticaStockResult = { remitoDescuenta };
  if (result.remitoDescuenta) {
    cachedOk = result;
  } else {
    cachedOk = null;
  }
  return result;
}
